import { getDefaultStatisticItem, getTeamLabelByNumber } from '../../utils/utils'

let lastPenaltyKicks = 0

export default {
  statisticScheme: {
    'GOAL': getDefaultStatisticItem(),
    'CORNER_KICK': getDefaultStatisticItem(),
    'PENALTY_THROW': getDefaultStatisticItem('statistic.water_polo.penalty_throw'),
    'SUCCESSFUL_PENALTY_THROW': getDefaultStatisticItem('statistic.water_polo.successful_penalty_throw', { percentFromTotal: true }),
    '20_SEC_EXCLUSION': getDefaultStatisticItem('statistic.water_polo.20_sec_penalty'),
    '4_MIN_EXCLUSION': getDefaultStatisticItem('statistic.water_polo.4_min_penalty')
  },
  statisticEvents: {
    'GOAL': 'GOAL',
    'CORNER_KICK': 'CORNER_KICK',
    'PENALTY_THROW': 'PENALTY_THROW',
    '20_SEC_EXCLUSION': '20_SEC_EXCLUSION',
    '4_MIN_EXCLUSION': '4_MIN_EXCLUSION'
  },
  statisticOrder: [
    'GOAL',
    'CORNER_KICK',
    'PENALTY_THROW',
    'SUCCESSFUL_PENALTY_THROW',
    '20_SEC_EXCLUSION',
    '4_MIN_EXCLUSION'
  ],
  statisticFunction (event) {
    const { EventCode, TeamNumber, GamePeriod } = event

    if (['HEARTBEAT', 'PLAYER_READY', 'POSSIBLE_GOAL'].includes(EventCode)) return

    if (EventCode === 'PENALTY_THROW') {
      this.updateStatisticTotal({
        statisticType: 'defaultStatistic',
        property: 'SUCCESSFUL_PENALTY_THROW',
        period: GamePeriod,
        team: getTeamLabelByNumber(TeamNumber),
        type: 'increment'
      })

      lastPenaltyKicks = TeamNumber

      return
    }

    if (EventCode === 'GOAL' && lastPenaltyKicks === TeamNumber) {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'SUCCESSFUL_PENALTY_THROW',
        period: GamePeriod,
        team: getTeamLabelByNumber(TeamNumber),
        type: 'increment'
      })

      return
    }

    lastPenaltyKicks = 0
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
